/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ivory_Gold_Bee_KnitInputs */

const en_ivory_gold_bee_knit = /** @type {(inputs: Ivory_Gold_Bee_KnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail`)
};

const de_ivory_gold_bee_knit = /** @type {(inputs: Ivory_Gold_Bee_KnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Adresse`)
};

/**
* | output |
* | --- |
* | "E-Mail" |
*
* @param {Ivory_Gold_Bee_KnitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ivory_gold_bee_knit = /** @type {((inputs?: Ivory_Gold_Bee_KnitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ivory_Gold_Bee_KnitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ivory_gold_bee_knit(inputs)
	return de_ivory_gold_bee_knit(inputs)
});